export enum LinuxServiceLoadState {
    Stub = 'stub',
    Loaded = 'loaded',
    NotFound = 'not-found',
    BadSetting = 'bad-setting',
    Error = 'error',
    Merged = 'merged',
    Masked = 'masked',
}
